import { useNativeSelector } from '@perpay-web/native-client/hooks/useNativeSelector';
import {
    getCanAddPaymentPass,
    getHasPaymentPass,
} from '@perpay-web/native-client/selectors/nativeWallet';
import { createContextProvider } from '@perpay-web/utils/componentUtils';

const useVirtualProvisioning = () => {
    const showAddToWalletMenu = useNativeSelector(getCanAddPaymentPass);
    const hasPaymentPass = useNativeSelector(getHasPaymentPass);

    return {
        showAddToWalletMenu,
        hasPaymentPass,
    };
};

const providerFactory = (Context) => {
    const Provider = ({ children }) => {
        const hook = useVirtualProvisioning();

        return <Context.Provider value={hook}>{children}</Context.Provider>;
    };

    return Provider;
};

export const [VirtualProvisioningProvider, useVirtualProvisioningContext] =
    createContextProvider(providerFactory);
